import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { WidgetActions } from './WidgetActions';

interface WidgetHeaderProps {
  title: string;
  removeWidget: () => void;
  refetch?: () => void;
  setSelectWidgetAI?: () => void;
  onPopout?: (widgetId: string) => void;
  onExport?: () => void;
  isExporting?: boolean;
  widgetId?: string;
  children?: React.ReactNode;
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  title,
  removeWidget,
  refetch,
  setSelectWidgetAI,
  onPopout,
  onExport,
  isExporting = false,
  widgetId,
  children,
}) => {
  return (
    <div className="flex justify-content-between align-items-center border-bottom-1 border-gray-700 widget-header">
      <div className="w-full flex justify-content-between align-items-center px-3 py-3">
        <div className="flex align-items-center">
          <span
            className="drag-handler"
            style={{
              color: 'var(--primary-color)',
              marginRight: '6px',
              marginLeft: '-3px',
              display: 'flex',
              alignItems: 'center',
            }}
            title="Move Widget"
          >
            <svg
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              aria-hidden="true"
              width="16"
              height="16"
              fill="currentColor"
            >
              <circle
                cx="5.5"
                cy="2.5"
                r="1.5"
                className="filled no-stroke"
              ></circle>
              <circle
                cx="5.5"
                cy="13.5"
                r="1.5"
                className="filled no-stroke"
              ></circle>
              <circle
                cx="5.5"
                cy="8"
                r="1.5"
                className="filled no-stroke"
              ></circle>
              <circle
                cx="10.5"
                cy="2.5"
                r="1.5"
                className="filled no-stroke"
              ></circle>
              <circle
                cx="10.5"
                cy="13.5"
                r="1.5"
                className="filled no-stroke"
              ></circle>
              <circle
                cx="10.5"
                cy="8"
                r="1.5"
                className="filled no-stroke"
              ></circle>
            </svg>
          </span>
          <h3
            className="mb-0"
            style={{ display: 'inline-block', marginRight: '8px' }}
          >
            {title}
          </h3>
          {onExport && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: '4px',
                verticalAlign: 'middle',
              }}
            >
              {isExporting ? (
                <i
                  className="pi pi-spin pi-spinner"
                  style={{
                    color: 'var(--primary-color)',
                    fontSize: '1.25rem',
                    cursor: 'not-allowed',
                  }}
                  title="Exporting PDF..."
                  data-pr-tooltip="Exporting PDF..."
                  aria-label="Exporting PDF"
                />
              ) : (
                <i
                  className="pi pi-file-pdf"
                  style={{
                    color: 'var(--primary-color)',
                    fontSize: '1.25rem',
                    cursor: 'pointer',
                  }}
                  title="Download as PDF"
                  data-pr-tooltip="Download as PDF"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onExport();
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  aria-label="Download as PDF"
                />
              )}
            </span>
          )}
          {children}
        </div>
        <div className="align-items-center flex flex-row">
          <WidgetActions
            onRemove={removeWidget}
            onRefresh={refetch ? () => refetch() : undefined}
            onAddToChat={setSelectWidgetAI || undefined}
            onPopout={onPopout}
            widgetId={widgetId || undefined}
            hideDragIcon={true}
          />
        </div>
      </div>
      {onExport && <Tooltip target=".pi-file-pdf" position="bottom" />}
    </div>
  );
};
